export default "__VITE_ASSET__DXyn8M4p__"